import { ZmToast } from '@zoom/zoom-ui-vue3';

import { withInstallFunctionNames } from '../utils/install';

import { EVENT_TYPES, emit } from '@/utils/event-emitter.js';

const originalMessage = ZmToast;

const notifyHandler = (instance, options) => {
  if (options.type === 'danger') {
    options.type = 'error';
  }
  emit(EVENT_TYPES.UI_MESSAGE, options);

  const messageEle = instance.$el;
  if (options.showClose) {
    const closeBtn = messageEle?.querySelector('.zbo-toast--closable');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        emit(EVENT_TYPES.UI_MESSAGE_CLICK_CLOSE, options);
      });
    }
  }

  const links = messageEle?.querySelectorAll('a[href]');
  links.forEach((link) => {
    link.addEventListener('click', () => {
      emit(EVENT_TYPES.UI_MESSAGE_CLICK_LINK, {
        linkText: link.textContent,
        ...options,
      });
    });
  });
};

const interceptMessage = (options) => {
  if (options.type === 'error') {
    options.type = 'danger'
  }
  const instance = originalMessage(options);
  notifyHandler(instance, options);
  return instance;
};

Object.keys(originalMessage).forEach((type) => {
  interceptMessage[type] = (...params) => {
    return originalMessage[type](params);
  };
});

['success', 'warning', 'info', 'error'].forEach(type => {
  interceptMessage[type] = (options) => {
    if (typeof options === 'string') {
      options = {
        message: options,
      };
    }

    if (type === 'error') {
      type = 'danger';
    }

    options.type = type;

    const instance = originalMessage(options);
    notifyHandler(instance, options);

    return instance;
  }
})

// override the $toast & $message
export const ZmMessage = withInstallFunctionNames(interceptMessage, ['$message', '$toast']);

export default ZmMessage;
